import { useTranslation } from "react-i18next";

const QuestionBox = ({
  onCancel,
  onAccept,
  title,
  details,
  cancelBtnText,
  acceptBtnText,
}) => {
  const { t } = useTranslation();

  return (
    <div className="questionBox">
      <div className="overlay" onClick={onCancel}></div>
      <div className="content">
        <h4 className="title">{title || ""}</h4>
        <span className="seperator"></span>
        <p className="details">{details || ""}</p>
        <span className="seperator"></span>
        <div className="btnGroup">
          <button className="btn" onClick={onCancel}>
            {cancelBtnText || t("questionBox.cancel")}
          </button>
          <button className="btn cancel" onClick={onAccept}>
            {acceptBtnText || t("questionBox.save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionBox;
